import { ISingleEventStatisticItem } from "routes/singleEvent/types";

export const MyStatisticsItem = ({ name, value }: ISingleEventStatisticItem) => (
  <div>
    <p className="tw-text-[18px] tw-font-medium tw-text-white lg:tw-font-semibold">{name}</p>
    <p className="lg:tw-leading-auto tw-mt-[4px] tw-text-[24px] tw-font-semibold tw-leading-[32px] tw-text-white lg:tw-mt-[8px] lg:tw-text-[32px]">
      {value}
    </p>
  </div>
)
